import React, {Component} from 'react';
import Icons from '../../Containers/Icons'

class Permissions extends Component {
  constructor() {
    super();
    this.state = {
      view: false,
      edit: false
    }
  }
  changePermissions = (per) => {
    let permissionState;
    this.state[per]
    ? permissionState = false
    : permissionState = true
    let bodyCall = {
      type: "update",
      screen: "user-tab-permissions",
      post: {
        tabID: this.props.tabID,
        uID: this.props.uID,
        [per]: true
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      this.props.readtabs();
      this.setState({[per]: permissionState})
    })
  }
  checkIfPermitted = (per) => {
    per = JSON.parse(per);
    const selected = per.find(key => {
      return key === parseInt(this.props.uID, 10)
    })
    if (selected !== undefined) {
      return true
    } else {
      return false
    }
  }
  render(){
    let {edit, view} = this.props;
    return (
      <div className="permissionsIcons">
        <div 
          className={`viewPer ${this.checkIfPermitted(view)}`}
          onClick={() => this.changePermissions("view")}>
          <Icons name="view"/>
        </div>
        <div 
          className={`editPer ${this.checkIfPermitted(edit)}`}
          onClick={() => this.changePermissions("edit")}>
          <Icons name="edit"/>
        </div>
      </div>
    )
  }
}

export default Permissions;


// WEBPACK FOOTER //
// ./src/Components/Admin/Permissions.js